const initialState = {
  mallSiteQnAStatus: 'all',

  startDate: undefined,
  endDate: undefined,
  searchOption: '',
  searchText: '',
  pageNumber: 1,
  totalSize: 0,
  isPushedSearchButton: false,
};

const resetState = {
  mallSiteQnAStatus: 'all',

  startDate: undefined,
  endDate: undefined,
  searchOption: '',
  searchText: '',
  pageNumber: 1,
  totalSize: 0,
  isPushedSearchButton: false,
};

const mallMyQnAReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SETMALLMYQNASTATUS':
      return {
        ...state,
        mallSiteQnAStatus: action.payload,
      };
    case 'SETMALLMYQNASTARTDATE':
      return {
        ...state,
        startDate: action.payload,
      };
    case 'SETMALLMYQNAENDDATE':
      return {
        ...state,
        endDate: action.payload,
      };
    case 'SETMALLMYQNASEARCHOPTION':
      return {
        ...state,
        searchOption: action.payload,
      };
    case 'SETMALLMYQNASEARCHTEXT':
      return {
        ...state,
        searchText: action.payload,
      };
    case 'SETMALLMYQNAPAGENUMBER':
      return {
        ...state,
        pageNumber: action.payload,
      };
    case 'SETMALLMYQNATOTALSIZE':
      return {
        ...state,
        totalSize: action.payload,
      };
    case 'SETMALLMYQNAISPUSHEDSEARCHBUTTON':
      return {
        ...state,
        isPushedSearchButton: action.payload,
      };
    case 'SETMALLMYQNARESET':
      return {
        ...state,
        ...resetState,
      };

    default:
      return state;
  }
};

export default mallMyQnAReducer;
